const sensors = require('sa-sdk-javascript')
const isProduction = process.env.NODE_ENV === 'production'
const serverUrl = `https://sac.danghuan.com/sa?project=${isProduction ? 'production' : 'default'}`
function initSensorsData() {
  sensors.init({
    server_url: serverUrl,
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      clickmap: 'default', // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      scroll_notice_map: 'default' // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    },
    show_log: true
  })
  // 注册公共属性
  sensors.registerPage({
    business_type: 'euOfficialSite'
  })
  sensors.quick('autoTrack') // 用于采集 $pageview 事件。
}
function sendSensorsMessage(messageNmae, messageBody) {
  sensors.track(messageNmae, messageBody)
}
export {
  initSensorsData,
  sendSensorsMessage
}
